import { Text, View } from '@react-pdf/renderer';
import { RHeader, RPage, RViewer } from '../../../components/PdfRender';
import { useCompany } from '../../../hooks/company';
import * as S from './styles';
import { IReponseFormData } from '../../interfaces';

interface IFormReportProps {
  response: IReponseFormData;
  validationCode?: string | null;
}

export const FormReport: React.FC<IFormReportProps> = ({
  response,
  validationCode,
}) => {
  const { company } = useCompany();

  return (
    <RViewer>
      <RPage>
        <View style={S.styles.container}>
          <RHeader company={company} />
          <View>
            <Text style={S.styles.nameText}>
              Nome: {response.form.client_name}
            </Text>
          </View>
          <View>
            <Text style={S.styles.nameText}>CPF: {response.form.cpf_cnpj}</Text>
          </View>
          <View style={S.styles.containerTitle}>
            <Text>{response.form.form_title.toUpperCase()}</Text>
          </View>
          {response.data.map((item, index) => (
            <>
              <View key={item.id} style={S.styles.containerQuestion}>
                <Text style={S.styles.questionText}>
                  {index + 1}. {item.input_label}
                </Text>
                <Text style={S.styles.answersText}>R. {item.value}</Text>
              </View>
            </>
          ))}
          {(validationCode || response.form.signature_validation_code) && (
            <View style={S.styles.validationCodeContainer}>
              <Text style={S.styles.validationCodeText}>
                Codigo de validacao:{' '}
                {validationCode || response.form.signature_validation_code}
              </Text>
            </View>
          )}
        </View>
      </RPage>
    </RViewer>
  );
};
